(function () {
  function moneyText(value) {
    return value || '';
  }

  function initSet(root) {
    if (!root || root.dataset.omSetReady === 'true') return;
    root.dataset.omSetReady = 'true';

    var radios = Array.prototype.slice.call(root.querySelectorAll('[data-set-variant]'));
    var variantId = root.querySelector('[data-set-variant-id]');
    var price = root.querySelector('[data-set-price]');
    var comparePrice = root.querySelector('[data-set-compare-price]');
    var saving = root.querySelector('[data-set-saving]');
    var buttonPrice = root.querySelector('[data-set-button-price]');
    var buttonLabel = root.querySelector('[data-set-button-label]');
    var shipping = root.querySelector('[data-set-shipping]');
    var title = root.querySelector('[data-set-title]');
    var lead = root.querySelector('[data-set-lead]');
    var aromaTitle = root.querySelector('[data-set-aroma-title]');
    var soapTitle = root.querySelector('[data-set-soap-title]');
    var aromaCountLabel = root.querySelector('[data-set-aroma-count]');
    var soapCountLabel = root.querySelector('[data-set-soap-count]');
    var soapBlock = root.querySelector('[data-set-soap-block]');
    var aromaGroups = Array.prototype.slice.call(root.querySelectorAll('[data-set-aroma-group]'));
    var soapGroups = Array.prototype.slice.call(root.querySelectorAll('[data-set-soap-group]'));
    var firstAroma = root.querySelector('[data-set-aroma-select]');
    var choiceSelects = Array.prototype.slice.call(root.querySelectorAll('[data-set-aroma-select], [data-set-soap-select]'));

    function updateChoice(select) {
      if (!select || select.selectedIndex < 0) return;
      var group = select.closest('[data-set-aroma-group], [data-set-soap-group]');
      var preview = group && group.querySelector('[data-aroma-choice]');
      var option = select.options[select.selectedIndex];
      if (!preview || !option) return;
      var name = preview.querySelector('[data-aroma-choice-name]');
      var note = preview.querySelector('[data-aroma-choice-note]');
      var image = preview.querySelector('[data-aroma-choice-image]');
      var color = preview.querySelector('[data-aroma-choice-color]');
      if (name) name.textContent = option.value;
      if (note) note.textContent = option.dataset.note || '';
      if (image && option.dataset.image) image.src = option.dataset.image;
      if (color) color.style.setProperty('--choice-color', option.dataset.color || '#f3dec9');
    }

    function setVisible(groups, count, prefix) {
      groups.forEach(function (group, index) {
        var select = group.querySelector('select');
        var visible = index < count;
        group.hidden = !visible;
        select.disabled = !visible;
        select.required = visible;
        if (visible) select.name = 'properties[' + prefix + ' ' + (index + 1) + ']';
        else select.removeAttribute('name');
      });
    }

    function updateTint() {
      if (!firstAroma) return;
      var option = firstAroma.options[firstAroma.selectedIndex];
      if (option && option.dataset.color) root.style.setProperty('--set-tint', option.dataset.color);
    }

    function applyVariant(radio) {
      if (!radio) return;
      var aromaCount = parseInt(radio.dataset.aromas || '0', 10);
      var soapCount = parseInt(radio.dataset.jabones || '0', 10);
      var displayPrice = moneyText(radio.dataset.price);
      var displayComparePrice = moneyText(radio.dataset.comparePrice);
      var displaySaving = moneyText(radio.dataset.saving);

      variantId.value = radio.value;
      price.textContent = displayPrice;
      if (comparePrice) {
        comparePrice.textContent = displayComparePrice;
        comparePrice.hidden = !displayComparePrice;
      }
      if (saving) {
        saving.textContent = displaySaving ? 'Ahorras ' + displaySaving : '';
        saving.hidden = !displaySaving;
      }
      buttonPrice.textContent = displayPrice;
      shipping.textContent = radio.dataset.freeShipping === 'true' ? 'Envío gratis incluido' : 'Despacho calculado al finalizar';
      if (title && radio.dataset.title) title.textContent = radio.dataset.title;
      if (lead && radio.dataset.lead) lead.textContent = radio.dataset.lead;
      if (buttonLabel) buttonLabel.textContent = radio.dataset.buttonLabel || 'Agregar al carro';
      if (aromaTitle) aromaTitle.textContent = 'Elige tus ' + aromaCount + ' aromas';
      if (soapTitle) soapTitle.textContent = soapCount === 1 ? 'Elige tu jabón de regalo' : 'Elige tus ' + soapCount + ' jabones';
      if (aromaCountLabel) aromaCountLabel.textContent = aromaCount + (aromaCount === 1 ? ' producto' : ' productos');
      if (soapCountLabel) soapCountLabel.textContent = soapCount + (soapCount === 1 ? ' producto' : ' productos');

      setVisible(aromaGroups, aromaCount, 'Aroma');
      setVisible(soapGroups, soapCount, 'Jabón');
      soapBlock.hidden = soapCount === 0;

      radios.forEach(function (item) {
        var card = item.closest('.om-set__variant');
        if (card) card.classList.toggle('is-on', item === radio);
      });
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () { applyVariant(radio); });
    });
    choiceSelects.forEach(function (select) {
      select.addEventListener('change', function () { updateChoice(select); });
      updateChoice(select);
    });
    if (firstAroma) firstAroma.addEventListener('change', updateTint);

    applyVariant(radios.find(function (radio) { return radio.checked; }) || radios[0]);
    updateTint();
  }

  function boot() {
    document.querySelectorAll('[data-om-set]').forEach(initSet);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
}());
